import type React from "react";
import { useCrmPermission } from "../../../hooks/useCrmPermission";
import { ContractTab } from "./components/ContractTab";
import { FocusMatterTab } from "./components/FocusMatterTab";
import { PipelineTab } from "./components/PipelineTab";

export type ActiveTab = "pipeline" | "focus-matters" | "contracts";

type SalesBoardPageProps = {
  activeTab: ActiveTab;
  onTabChange: (tab: ActiveTab) => void;
};

/**
 * 営業ボードページのプレゼンテーションコンポーネント
 * @param {object} props プロパティ
 * @param {string} props.activeTab アクティブなタブ
 * @param {Function} props.onTabChange タブ変更ハンドラ
 * @return {React.ReactElement} 営業ボードページ
 */
export const SalesBoardPage: React.FC<SalesBoardPageProps> = ({
  activeTab,
  onTabChange,
}) => {
  const { canEdit, canManageContracts } = useCrmPermission();

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">営業ボード</h1>

      {/* Tabs */}
      <div role="tablist" className="tabs tabs-bordered mb-4">
        <button
          type="button"
          role="tab"
          className={`tab ${activeTab === "pipeline" ? "tab-active" : ""}`}
          onClick={() => onTabChange("pipeline")}
        >
          パイプライン
        </button>
        <button
          type="button"
          role="tab"
          className={`tab ${activeTab === "focus-matters" ? "tab-active" : ""}`}
          onClick={() => onTabChange("focus-matters")}
        >
          注力案件
        </button>
        <button
          type="button"
          role="tab"
          className={`tab ${activeTab === "contracts" ? "tab-active" : ""}`}
          onClick={() => onTabChange("contracts")}
        >
          契約
        </button>
      </div>

      {/* Tab content */}
      {activeTab === "pipeline" && <PipelineTab canEdit={canEdit} />}
      {activeTab === "focus-matters" && <FocusMatterTab canEdit={canEdit} />}
      {activeTab === "contracts" && (
        <ContractTab canManageContracts={canManageContracts} />
      )}
    </div>
  );
};
